import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  changeTableData,
  changeIsAllChecked,
} from '../../../features/dashboard/dashboardSlice';
import Button from '../Button/Button';
import api from '../../../config/api';
import css from './Tables.module.css';
import moment from 'moment';

const tableData = [
  {
    id: 1,
    date: 'October 12, 2022',
    amount: '455.00 USD',
    status: 'OK',
  },
  {
    id: 2,
    date: 'September 12, 2022',
    amount: '455.00 USD',
    status: 'OK',
  },
  {
    id: 3,
    date: 'August 12, 2022',
    amount: '455.00 USD',
    status: 'OK',
  },
];

const InvoicesTable = ({ type, data }) => {
  //   const { tableData } = useSelector(state => state.dashboard);

  const dispatch = useDispatch();

  useEffect(() => {
    //   api
    //     .GET_CLIENT_BUDGET_PACING()
    //     .then(
    //       res =>
    //         res.status === 'OK' &&
    //         dispatch(
    //           changeTableData(
    //             res.data.map(el => ({ ...el, isChecked: false })),
    //           ),
    //         ),
    //     );
  }, [type]);

  return (
    <table className={css.table}>
      <thead className={css.thead}>
        <tr className={css.trHead}>
          <th className={css.th}>Invoice Date</th>
          <th className={css.th}>Amount Paid</th>
          <th className={css.th}>Status</th>
          <th className={css.th}>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td colSpan={4}>
            <div className={`${css.tbody} ${css.invoicesBody}`}>
              <table className={css.table2}>
                <tbody>
                  {data.length > 0 &&
                    data.map(el => (
                      <tr key={el.id}>
                        <td className={css.tdP}>
                          {moment(el.date).format('MMMM DD, YYYY')}
                        </td>
                        <td className={css.tdP}>{el.amount.toFixed(2)} USD</td>
                        <td
                          className={`${css.tdP} ${
                            el.status === 'Paid' ? css.green : css.red
                          }`}
                        >
                          {el.status === 'Paid' ? 'Paid' : 'Pending'}
                        </td>
                        <td className={css.tdP}>
                          <Button
                            styled="download"
                            onClick={() => {
                              window.open(el.pdf_link);
                            }}
                          />
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default InvoicesTable;
